import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import VueDatePicker from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import "@/assets/sass/main.scss";
import { firestorePlugin, rtdbPlugin } from "vuefire";
import { getUser, logout } from "./modules/auth";
import OtpInput from "@bachdgvn/vue-otp-input";

import i18n from "./i18n";
import AOS from "aos";

// import Default from "./layouts/Default.vue";
import Default from "./layouts/default.vue";
import Blank from "./layouts/empty.vue";
import Vuelidate from "vuelidate";
import Toasted from "vue-toasted";
import VueSignaturePad from "vue-signature-pad";

let option = {
  duration: 3000,
  keepOnHover: true,
};

Vue.use(Toasted, option);

// Vue.component("default-layout", Default);
Vue.component("default-layout", Default);
Vue.component("blank-layout", Blank);
Vue.component("otp-input", OtpInput);

// plugins
Vue.use(VueDatePicker);
Vue.use(firestorePlugin);
Vue.use(rtdbPlugin);
Vue.use(Vuelidate);
Vue.use(VueSignaturePad);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  mounted() {
    getUser();
  },
  methods: {
    logout() {
      logout().then(() => {
        this.toast("Logged out", "success");
        // if (this.$route.meta?.title !== "Route Line") {
        // router.push("/");
        window.location.href = "https://routeline.com/";
        // }
      });
    },
    toast(text, type) {
      const payload = {
        message: text,
        type: type || "info",
      };
      this.$store.dispatch({
        type: "SNACKBAR",
        payload,
      });
    },
  },
  created() {
    AOS.init();
  },
  render: (h) => h(App),
}).$mount("#app");
